// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Limpeza",
    laundry: "Lavanderia",
    maintenance: "Manutenção e reparos",
    supplies: "Utensílios e itens de consumo",
    utilities: "Contas de consumo (água, luz, gás)",
    staff: "Equipe",
    software: "Software e ferramentas",
    marketing: "Publicidade",
    taxes: "Impostos e taxas",
    other: "Outros",
  },

  restricted: "As despesas da gestão só são visíveis para a conta principal: o seu acesso está limitado a algumas acomodações.",

  summary: {
    aria: "Resumo das despesas do período. Selecione um valor para filtrar a tabela.",
    total: "Total de despesas",
    count: "{n} despesa | {n} despesas",
    charged: "Repassadas aos proprietários",
    chargedHint: "Descontadas nos extratos deles",
    own: "Próprias da gestão",
    ownHint: "Reduzem o seu lucro",
  },

  toolbar: {
    search: "Buscar",
    searchPlaceholder: "Descrição ou fornecedor",
    clearSearch: "Limpar busca",
    category: "Categoria",
    allCategories: "Todas",
    listing: "Acomodação",
    allListings: "Todas",
    type: "Tipo",
    allTypes: "Todas",
    charged: "Repassadas ao proprietário",
    own: "Próprias",
    create: "Nova despesa",
  },

  table: {
    date: "Data",
    category: "Categoria",
    concept: "Descrição",
    listing: "Acomodação",
    chargedTo: "Por conta de",
    amount: "Valor",
    receipt: "Recibo",
    actions: "Ações",
    general: "Geral",
    management: "Gestão",
    ownerMissing: "Sem proprietário atribuído",
    notCharged: "A acomodação não é mais gerida: esta despesa não é cobrada de ninguém",
    vat: "IVA {pct}%",
    download: "Baixar o recibo",
    edit: "Editar",
    remove: "Excluir",
  },

  empty: {
    title: "Nenhuma despesa neste período",
    text: "Registre o que você paga (limpeza, lavanderia, reparos, software…) e decida se é repassado ao proprietário ou se é uma despesa da gestão.",
    create: "Registrar uma despesa",
    filteredTitle: "Nenhuma despesa corresponde aos filtros",
    filteredText: "Tente outra busca ou remova os filtros para ver todas as despesas do período.",
    clear: "Remover filtros",
  },

  load: {
    error: "Não foi possível carregar as despesas.",
    retry: "Tentar novamente",
  },

  remove: {
    title: "Excluir esta despesa?",
    message: "“{concept}” ({amount}) deixará de contar na análise e nos extratos dos proprietários.",
    confirm: "Excluir",
    done: "Despesa excluída",
    error: "Não foi possível excluir a despesa. Tente novamente.",
  },

  receiptError: "Não foi possível baixar o recibo.",

  drawer: {
    newTitle: "Nova despesa",
    editTitle: "Editar despesa",
    newSubtitle: "O que você paga pela gestão, por conta do proprietário ou da sua empresa de gestão.",
    editSubtitle: "As alterações aparecem na hora na análise e nos extratos.",
    close: "Fechar",
    sections: {
      expense: "A despesa",
      listing: "Acomodação e proprietário",
      notes: "Observações",
      receipt: "Recibo ou nota fiscal",
    },
    fields: {
      concept: "Descrição",
      conceptPlaceholder: "Ex.: Limpeza de saída",
      category: "Categoria",
      date: "Data",
      supplier: "Fornecedor",
      supplierPlaceholder: "Ex.: Lavanderia Sol",
      amount: "Valor",
      vat: "IVA",
      vatHint: "Apenas informativo: o valor é o que você pagou, com impostos incluídos.",
      listing: "Acomodação",
      listingGeneral: "Despesa geral da gestão (sem acomodação)",
      unit: "Unidade",
      unitAll: "Toda a acomodação",
      notesPlaceholder: "Qualquer detalhe que queira lembrar",
    },
    charge: {
      label: "Repassar ao proprietário",
      general: "Uma despesa geral é sempre da gestão. Escolha uma acomodação para cobrá-la do proprietário.",
      loading: "Verificando a acomodação…",
      error: "Não foi possível verificar se esta acomodação é gerida.",
      retry: "Tentar novamente",
      notManaged: "Esta acomodação não está marcada como gerida: a despesa conta como sua.",
      notManagedMarked: "A acomodação não é mais gerida: a despesa não é cobrada de ninguém. Desative para deixá-la como despesa própria.",
      own: "Se não repassar, conta como despesa própria da gestão.",
      owner: "Será descontada no extrato de {owner}.",
      noOwner: "A acomodação ainda não tem proprietário atribuído: será descontada no extrato de quem você atribuir.",
    },
    receipt: {
      drop: "Arraste aqui a foto ou o PDF",
      pick: "ou escolha um arquivo",
      formats: "JPG, PNG, WEBP, HEIC ou PDF · máx. 10 MB",
      current: "Recibo salvo",
      download: "Baixar",
      change: "Substituir",
      remove: "Remover",
      undo: "Desfazer",
      willRemove: "O recibo será removido ao salvar.",
      willReplace: "substituirá o salvo",
      tooBig: "O arquivo tem mais de 10 MB.",
      badType: "Formato não suportado: envie uma foto (JPG, PNG, WEBP ou HEIC) ou um PDF.",
    },
    errors: {
      required: "Este campo é obrigatório.",
      category: "Escolha uma categoria.",
      amount: "Informe um valor maior que 0.",
      vat: "Informe uma porcentagem entre 0 e 100.",
      review: "Revise os campos destacados.",
      generic: "Não foi possível salvar a despesa. Tente novamente.",
    },
    discard: {
      title: "Descartar as alterações?",
      message: "O que você preencheu nesta despesa será perdido.",
      confirm: "Descartar",
      cancel: "Continuar editando",
    },
    cancel: "Cancelar",
    save: "Salvar despesa",
    saveChanges: "Salvar alterações",
    saving: "Salvando…",
    created: "Despesa salva",
    updated: "Alterações salvas",
    outOfPeriod: "Salva. A data ({date}) fica fora do período que você está vendo.",
  },
};
